export default __webpack_public_path__ + "static/ib-school-6a2f7bf49d297d196420e5665202ed2e.svg";